"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
const react_1 = __importDefault(require("react"));
const Routes_1 = __importDefault(require("../routes/Routes"));
const ThemeContext_1 = require("./ThemeContext");
exports.default = () => {
    return (react_1.default.createElement(ThemeContext_1.ThemeProvider, null,
        react_1.default.createElement(Routes_1.default, null)));
};
